import { Breadcrumbs } from '@monorepo/shared/componentsV2/Breadcrumbs';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { useHasOrgUpdatePermissionOrSuperAdmin } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import { WorkflowResponse } from 'mapistry-shared';
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { RouteEditMode } from '../types';

const StyledHeader = styled(Header)`
  background-color: ${({ theme }) => theme.colors.blue04};
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  padding: 0;
` as typeof Breadcrumbs;

export function WorkflowDetailsHeader({
  organizationId,
  workflow,
}: {
  organizationId: string;
  workflow: WorkflowResponse;
}) {
  const canEditWorkflow = useHasOrgUpdatePermissionOrSuperAdmin(organizationId);
  const navigate = useNavigate();
  const crumbs = useMemo(
    () => [
      { label: 'Workflows', to: './..' },
      { label: workflow.name || 'Unnamed workflow', to: '.' },
    ],
    [workflow.name],
  );
  const editWorkflowOnClick = useCallback(() => {
    navigate(`./${RouteEditMode.EDIT}`);
  }, [navigate]);

  return (
    <StyledHeader
      title={<StyledBreadcrumbs crumbs={crumbs} />}
      variant="noDropShadow"
      rightActions={
        canEditWorkflow ? (
          <Button
            color="primary"
            variant="contained"
            onClick={editWorkflowOnClick}
          >
            Edit workflow
          </Button>
        ) : undefined
      }
    />
  );
}
